<template>
    <div class="GenericDataTable" style="display:flex;flex-direction:column; max-height:85vh;">


        <!--FILTERS / SEARCH-->
        <div class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4" v-for="Filter in DataFilters">
                    <div class="form-group">
                        <label>{{ Filter.Label }}:</label>
                        <select class="form-control" v-model="Filter.Value" @change="GetData()">
                            <option v-for="option in Filter.Options" :value="option.value">{{ option.text }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <p>Displaying {{NumberOfRecords}} Records</p>
                    <h3><span v-b-tooltip.hover title="Refresh Data"><font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="GetData()" class="olive-green-text pointer" /></span></h3>
                </div>
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Records:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
        </div>


        <!--TABLE-->
        <div style="overflow:auto">
            <vuetable :fields="TableFields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable">

                <template v-for="slot in TableSlots" :slot="slot.Name" scope="props">
                    <div :class="slot.Name">
                        <span class="underline pointer" @click="DispatchSlotClick(slot.EventName, props.rowData)">{{ props.rowData[slot.DisplayProperty] }}</span>
                    </div>
                </template>
            </vuetable>
        </div>
    </div>
</template>
<script>
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import SelectFromEndpoint from '../CustomInputElements/SelectFromEndpoint.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);

    export default {
        props: [
            "TableFields",//array
            "DataFilters",//array
            "TableSlots",//array
            "DataEndpoint",//string
            "DataMethod",//string GET, POST
            "LoadIndicator",//bool
            "DataCommitName",//string, nullable
            "LoadDataOnMounted"//bool
        ],
        data: function () {
            return {
                NumberOfRecords: '',
                search: "",
                DataResult: []
            };
        },
        methods: {
            GetData(loadIndicator = null) {
                let filters = {};
                this.DataFilters.forEach(function (item) {
                    filters[item.Name] = item.Value;
                });
                //console.log("FILTERS:");
                //console.log(filters);

                this.$MasterAPI.ExecuteRequest(this.DataMethod, this.DataEndpoint, filters, this.GetDataSuccess, () => { }, loadIndicator == null ? this.LoadIndicator : loadIndicator);
            },
            GetDataResult() {
                return this.DataResult;
            },
            GetDataSuccess(response) {
                if (this.DataCommitName) {
                    this.$store.commit(this.DataCommitName, response.data.data);
                }
                this.DataResult = response.data.data;
                
                this.$refs.datatable.refresh();
            },
            DispatchSlotClick(eventName, rowData) {
                this.$emit(eventName, rowData);
            },
            //TABLE UI DATA HANDLERS
            
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.DataResult);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));

                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfRecords = visibleData.length;
                return visibleData;
            },
            //AUX METHODS
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            Vuetable,
            SelectFromEndpoint
        },
        mounted() {
            if (this.LoadDataOnMounted) {
                this.GetData();
            }
        }
    };
</script>


<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>